import { createI18n } from 'vue-i18n'
import vi from './tVi.json';
import ja from './tJa.json';
import en from './tEn.json';
const i18n = createI18n({
  locale: 'vi',
  fallbackLocale: 'ja',
  messages: {
    vi,
    ja,
    en
  },
})

export default i18n;